import Image from 'next/image'

import { Dialog } from '@/components/common/Feedback/Dialog/Dialog'
import { pagesPath } from '@/lib/$path'

import { MypageSetting } from '../../Navigation'

type AppDownloadDialogProps = {
  isOpen: boolean
  onClose: () => void
}

export const AppDownloadDialog = ({
  isOpen,
  onClose,
}: AppDownloadDialogProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      hasCancelButton={false}
      onClose={onClose}
      title=""
      isPaddingRight={false}
      body={
        <div className="flex justify-center items-end w-full">
          <Image
            src={'/modal-app-icon.png'}
            width={112}
            height={27}
            alt="アバター画像"
          />
          <p className="text-sm font-bold">アプリのDLはこちら</p>
        </div>
      }
      extraBody={
        <div className="flex flex-col items-center mb-[315px] w-full">
          <div className="flex text-black">
            <div>
              <p className="text-sm font-bold text-center">iOSアプリ</p>
              <div className="mb-[64px]">
                <Image
                  src={'/bump-qr-ios.png'}
                  width={160}
                  height={160}
                  alt="QRコード"
                />
              </div>
            </div>
            <div>
              <p className="text-sm font-bold text-center">Androidアプリ</p>
              <div className="mb-[64px]">
                <Image
                  src={'/bump-qr-android.png'}
                  width={160}
                  height={160}
                  alt="QRコード"
                />
              </div>
            </div>
          </div>
          <MypageSetting
            title="プライバシーポリシー"
            urlPath={pagesPath.rules.privacy_policy.$url().pathname}
            textColor="black"
            borderColor="black"
            iconColor="black"
          />
          <MypageSetting
            title="よくある質問"
            urlPath={pagesPath.question.$url().pathname}
            textColor="black"
            borderColor="black"
            iconColor="black"
          />
        </div>
      }
    />
  )
}
